export const PRODUCT_SEARCH_QUERY = `
  query ProductsByNameORSku($search: String!) {
    productsByNameORSku(search: $search) {
      name
      sku
    }
  }
`
